export const isPastMonth = (date, referenceDate = new Date()) => {
  if (!date) return false;

  const [year, month] = date instanceof Date
    ? [date.getFullYear(), date.getMonth() + 1]
    : String(date).split("-").map(Number);

  if (!Number.isFinite(year) || !Number.isFinite(month) || month < 1 || month > 12) return false;

  const currentMonth = referenceDate.getMonth() + 1;
  const currentYear = referenceDate.getFullYear();

  return year < currentYear || (year === currentYear && month < currentMonth);
};

export const isPastNegotiationDate = (dateStr, status, emNegociacaoStatusId, referenceDate = new Date()) =>
  status === emNegociacaoStatusId && isPastMonth(dateStr, referenceDate);

export const negotiationDateToSortKey = (dateStr) => {
  if (!dateStr) return Number.POSITIVE_INFINITY;
  const [day, month, year] = dateStr.split("/").map((n) => Number(n));
  if (!day || !month) return Number.POSITIVE_INFINITY;
  const today = new Date();
  const y = year || today.getFullYear();
  return new Date(y, month - 1, day).getTime();
};
